/**
 * `<ForbiddenPage>` — 403 fallback rendered by route-level role gates
 * (W20-F1-S1; reused across all admin surfaces).
 *
 * Uses the existing `<EmptyState>` shell so the visual matches the
 * "blocked card" treatment from the admin landing page. Provides a
 * clear back-to-dashboard escape so a user landing here without the
 * right role isn't stuck.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldOff } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

export function ForbiddenPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main
      className="flex min-h-[60vh] items-center justify-center p-6"
      data-testid="forbidden-page"
    >
      <EmptyState
        icon={<ShieldOff className="h-10 w-10" />}
        title={t('forbidden.title')}
        description={t('forbidden.description')}
        action={
          <Button asChild variant="outline">
            <Link to="/dashboard">{t('forbidden.backToDashboard')}</Link>
          </Button>
        }
      />
    </main>
  );
}

export default ForbiddenPage;
